import DropdownIcon from "../../../public/assets/arrow-down-drop.svg";

export default DropdownIcon;
